export default __webpack_public_path__ + "static/c04-061165874f973a26a0d1e8edc510947c.png";